"use strict";

var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");

const _excluded = ["size", "type", "className"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconList = _interopRequireDefault(require("./icon-list"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

const Icon = _ref => {
  let {
    size,
    type,
    className
  } = _ref,
      iconProps = _objectWithoutProperties(_ref, _excluded);

  let IconSVG;

  try {
    IconSVG = require("./assets/".concat(size, "/").concat(type, ".inline.svg")); // eslint-disable-next-line no-empty
  } catch (err) {}

  return IconSVG ? /*#__PURE__*/_react.default.createElement(IconSVG, (0, _extends2.default)({
    className: (0, _classnames.default)(_indexModule.default.Icon, className)
  }, iconProps)) : null;
};

const validateType = props => {
  const {
    size,
    type
  } = props;

  if (!type) {
    return new Error('Prop type is required for Icon');
  }

  if (!size || !_iconList.default[size].includes(type)) {
    return new Error("Invalid type, or size combination for icon: ".concat(type));
  }

  return null;
};

Icon.defaultProps = {
  size: 'medium'
};
Icon.propTypes = {
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  type: validateType,
  className: _propTypes.default.string
};

var _default = exports.default = Icon;